import { Box, chakra, HStack, Link, Stack } from '@chakra-ui/react';
import { DigitalTwinDataFragment } from '../../generated/graphql';
import {
  FaFacebook,
  FaFolder,
  FaGlobe,
  FaInstagram,
  FaLinkedin,
  FaTiktok,
  FaTwitter,
  FaYoutube,
} from 'react-icons/fa';
import { HelivanColor } from '../helivan/HelivanColor';
import { HelivanText } from '../helivan/HelivanText';
import { capitalize } from '../../utils/capitalize';

export const DigitalTwinMetadata = ({
  digitalTwin,
  size,
}: {
  digitalTwin: DigitalTwinDataFragment;
  size?: 'sm' | 'lg';
}) => {
  return (
    <Stack>
      {digitalTwin.congressData && (
        <Stack spacing="2">
          {(digitalTwin.congressData.linkedinHandle ||
            digitalTwin.congressData.twitterHandle) && (
            <HStack spacing={2}>
              {!!digitalTwin.congressData.linkedinHandle && (
                <Box
                  onClick={() => {
                    window.open(
                      `https://www.linkedin.com/in/${
                        digitalTwin.congressData?.linkedinHandle
                      }`,
                      '_blank'
                    );
                  }}
                  cursor="pointer"
                >
                  <FaLinkedin
                    size={size === 'lg' ? 24 : 16}
                    color={HelivanColor.text.blueDark}
                  />
                </Box>
              )}
              {!!digitalTwin.congressData.twitterHandle && (
                <Box
                  onClick={() => {
                    window.open(
                      `https://x.com/${digitalTwin.congressData?.twitterHandle}`,
                      '_blank'
                    );
                  }}
                  cursor="pointer"
                >
                  <FaTwitter
                    size={size === 'lg' ? 24 : 16}
                    color={HelivanColor.text.blueDark}
                  />
                </Box>
              )}
            </HStack>
          )}

          <Stack spacing={0}>
            <HelivanText variant={size === 'lg' ? 'largeBody' : 'smallBody'}>
              <chakra.span color={HelivanColor.text.gray}>Party: </chakra.span>
              {capitalize(digitalTwin.congressData.party)}
            </HelivanText>
            <HelivanText variant={size === 'lg' ? 'largeBody' : 'smallBody'}>
              <chakra.span color={HelivanColor.text.gray}>
                Chamber:{' '}
              </chakra.span>
              {capitalize(digitalTwin.congressData.chamber)}
            </HelivanText>
            <HelivanText variant={size === 'lg' ? 'largeBody' : 'smallBody'}>
              <chakra.span color={HelivanColor.text.gray}>State: </chakra.span>
              {digitalTwin.congressData.state.toUpperCase()}
            </HelivanText>
          </Stack>
        </Stack>
      )}
      {digitalTwin.sendrilData && (
        <Stack spacing="2">
          <HStack spacing={2}>
            {!!digitalTwin.sendrilData?.facebookHandle && (
              <Box
                onClick={() => {
                  window.open(
                    `https://www.facebook.com/${
                      digitalTwin.sendrilData?.facebookHandle
                    }`,
                    '_blank'
                  );
                }}
                cursor="pointer"
              >
                <FaFacebook
                  size={size === 'lg' ? 24 : 16}
                  color={HelivanColor.text.blueDark}
                />
              </Box>
            )}
            {!!digitalTwin.sendrilData?.tiktokHandle && (
              <Box
                onClick={() => {
                  window.open(
                    `https://www.tiktok.com/@${digitalTwin.sendrilData?.tiktokHandle}`,
                    '_blank'
                  );
                }}
                cursor="pointer"
              >
                <FaTiktok
                  size={size === 'lg' ? 24 : 16}
                  color={HelivanColor.text.blueDark}
                />
              </Box>
            )}
            {!!digitalTwin.sendrilData?.instagramHandle && (
              <Box
                onClick={() => {
                  window.open(
                    `https://www.instagram.com/${digitalTwin.sendrilData?.instagramHandle}`,
                    '_blank'
                  );
                }}
                cursor="pointer"
              >
                <FaInstagram
                  size={size === 'lg' ? 24 : 16}
                  color={HelivanColor.text.blueDark}
                />
              </Box>
            )}
            {!!digitalTwin.sendrilData?.youtubeHandle && (
              <Box
                onClick={() => {
                  window.open(
                    `https://www.youtube.com/@${digitalTwin.sendrilData?.youtubeHandle}`,
                    '_blank'
                  );
                }}
                cursor="pointer"
              >
                <FaYoutube
                  size={size === 'lg' ? 24 : 16}
                  color={HelivanColor.text.blueDark}
                />
              </Box>
            )}
            {!!digitalTwin.sendrilData?.substackHandle && (
              <Box
                onClick={() => {
                  window.open(
                    `https://www.substack.com/${digitalTwin.sendrilData?.substackHandle}`,
                    '_blank'
                  );
                }}
                cursor="pointer"
              >
                <FaFolder
                  size={size === 'lg' ? 24 : 16}
                  color={HelivanColor.text.blueDark}
                />
              </Box>
            )}
            {!!digitalTwin.sendrilData && !!digitalTwin.sendrilData.website && (
              <Box
                onClick={() => {
                  window.open(digitalTwin.sendrilData!.website!, '_blank');
                }}
                cursor="pointer"
              >
                <FaGlobe
                  size={size === 'lg' ? 24 : 16}
                  color={HelivanColor.text.blueDark}
                />
              </Box>
            )}
          </HStack>
        </Stack>
      )}
      {digitalTwin.earlyStageVcData && (
        <Stack spacing="2">
          {(digitalTwin.earlyStageVcData?.linkedinHandle ||
            digitalTwin.earlyStageVcData?.twitterHandle) && (
            <HStack spacing={2}>
              {!!digitalTwin.earlyStageVcData?.linkedinHandle && (
                <Box
                  onClick={() => {
                    window.open(
                      `https://www.linkedin.com/in/${
                        digitalTwin.earlyStageVcData?.linkedinHandle
                      }`,
                      '_blank'
                    );
                  }}
                  cursor="pointer"
                >
                  <FaLinkedin
                    size={size === 'lg' ? 24 : 16}
                    color={HelivanColor.text.blueDark}
                  />
                </Box>
              )}
              {!!digitalTwin.earlyStageVcData?.twitterHandle && (
                <Box
                  onClick={() => {
                    window.open(
                      `https://x.com/${digitalTwin.earlyStageVcData?.twitterHandle}`,
                      '_blank'
                    );
                  }}
                  cursor="pointer"
                >
                  <FaTwitter
                    size={size === 'lg' ? 24 : 16}
                    color={HelivanColor.text.blueDark}
                  />
                </Box>
              )}
            </HStack>
          )}
          <Stack spacing={0}>
            <HelivanText variant={size === 'lg' ? 'largeBody' : 'smallBody'}>
              <chakra.span color={HelivanColor.text.gray}>Firm: </chakra.span>
              {capitalize(digitalTwin.earlyStageVcData.firm)}
            </HelivanText>
            {digitalTwin.earlyStageVcData.title && (
              <HelivanText variant={size === 'lg' ? 'largeBody' : 'smallBody'}>
                <chakra.span color={HelivanColor.text.gray}>
                  Position:{' '}
                </chakra.span>
                {capitalize(digitalTwin.earlyStageVcData.title)}
              </HelivanText>
            )}
          </Stack>
        </Stack>
      )}
      {digitalTwin.fortuneCeoData && (
        <Stack spacing="2">
          {(digitalTwin.fortuneCeoData?.linkedinHandle ||
            digitalTwin.fortuneCeoData?.twitterHandle) && (
            <HStack spacing={2}>
              {!!digitalTwin.fortuneCeoData?.linkedinHandle && (
                <Box
                  onClick={() => {
                    window.open(
                      `https://www.linkedin.com/in/${
                        digitalTwin.fortuneCeoData?.linkedinHandle
                      }`,
                      '_blank'
                    );
                  }}
                  cursor="pointer"
                >
                  <FaLinkedin
                    size={size === 'lg' ? 24 : 16}
                    color={HelivanColor.text.blueDark}
                  />
                </Box>
              )}
              {!!digitalTwin.fortuneCeoData?.twitterHandle && (
                <Box
                  onClick={() => {
                    window.open(
                      `https://x.com/${digitalTwin.fortuneCeoData?.twitterHandle}`,
                      '_blank'
                    );
                  }}
                  cursor="pointer"
                >
                  <FaTwitter
                    size={size === 'lg' ? 24 : 16}
                    color={HelivanColor.text.blueDark}
                  />
                </Box>
              )}
            </HStack>
          )}

          <Stack spacing={0}>
            <HelivanText variant={size === 'lg' ? 'largeBody' : 'smallBody'}>
              <chakra.span color={HelivanColor.text.gray}>
                Company:{' '}
              </chakra.span>
              {capitalize(digitalTwin.fortuneCeoData.company)}
            </HelivanText>
            <HelivanText variant={size === 'lg' ? 'largeBody' : 'smallBody'}>
              <chakra.span color={HelivanColor.text.gray}>
                Industry:{' '}
              </chakra.span>
              {capitalize(digitalTwin.fortuneCeoData.industry)}
            </HelivanText>
          </Stack>
        </Stack>
      )}
      {digitalTwin.nycMayorData && (
        <Stack spacing="2">
          <Box
            onClick={() => {
              window.open(
                `https://x.com/${digitalTwin.nycMayorData?.twitterHandle}`,
                '_blank'
              );
            }}
            cursor="pointer"
          >
            <FaTwitter
              size={size === 'lg' ? 24 : 16}
              color={HelivanColor.text.blueDark}
            />
          </Box>
          <HelivanText variant={size === 'lg' ? 'largeBody' : 'smallBody'}>
            <Link href={digitalTwin.nycMayorData.website} target="_blank">
              {digitalTwin.nycMayorData.website}
            </Link>
          </HelivanText>
        </Stack>
      )}
      {digitalTwin.modelData && (
        <Stack spacing="2">
          {digitalTwin.modelData.score && (
            <HelivanText variant={size === 'lg' ? 'largeBody' : 'smallBody'}>
              <chakra.span color={HelivanColor.text.gray}>Score: </chakra.span>
              {digitalTwin.modelData.score}
            </HelivanText>
          )}
          {digitalTwin.modelData.baseModel && (
            <HelivanText variant={size === 'lg' ? 'largeBody' : 'smallBody'}>
              <chakra.span color={HelivanColor.text.gray}>
                Base Model:{' '}
              </chakra.span>
              {digitalTwin.modelData.baseModel}
            </HelivanText>
          )}
          {digitalTwin.modelData.systemPrompt && (
            <HelivanText variant={size === 'lg' ? 'largeBody' : 'smallBody'}>
              <chakra.span color={HelivanColor.text.gray}>
                System Prompt:{' '}
              </chakra.span>
              {digitalTwin.modelData.systemPrompt}
            </HelivanText>
          )}
          {digitalTwin.modelData.temperature && (
            <HelivanText variant={size === 'lg' ? 'largeBody' : 'smallBody'}>
              <chakra.span color={HelivanColor.text.gray}>
                Temperature:{' '}
              </chakra.span>
              {digitalTwin.modelData.temperature}
            </HelivanText>
          )}
          {digitalTwin.modelData.maxNewTokens && (
            <HelivanText variant={size === 'lg' ? 'largeBody' : 'smallBody'}>
              <chakra.span color={HelivanColor.text.gray}>
                Max New Tokens:{' '}
              </chakra.span>
              {digitalTwin.modelData.maxNewTokens}
            </HelivanText>
          )}
          {digitalTwin.modelData.numReturnSequences && (
            <HelivanText variant={size === 'lg' ? 'largeBody' : 'smallBody'}>
              <chakra.span color={HelivanColor.text.gray}>
                Num Return Sequences:{' '}
              </chakra.span>
              {digitalTwin.modelData.numReturnSequences}
            </HelivanText>
          )}
        </Stack>
      )}
    </Stack>
  );
};
